export default "__VITE_ASSET__DXTFq5lw__"